var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLogoDarkMode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 426 95",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsserif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.00384,0,0,0.963661,-10.0546,4.16106)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,1.99235,-10.1892)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.05622,0,0,0.921649,-185.051,-202.31)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.175524,0,0,0.191968,71.0285,-27.5065)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M784.731,1341.13C801.545,1467.34 684.759,1635 684.759,1684.89C684.759,1732.32 721.54,1770.83 784.731,1770.83C847.923,1770.83 882.625,1730.58 882.625,1683.15C882.625,1633.26 826.767,1435.79 784.731,1341.13Z",
    style: {
      fill: "rgb(87,150,185)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.141577,0,0,0.154232,314.272,35.9811)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M794.352,1341.13C812.441,1513.01 670.236,1633.32 670.236,1684.89C670.236,1732.32 721.54,1770.83 784.731,1770.83C847.923,1770.83 874.559,1724.28 874.559,1676.85C874.559,1625.28 846.789,1470.04 794.352,1341.13Z",
    style: {
      fill: "rgb(87,150,185)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-33.2057,-30.5026)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,-0.000305987,0.000305987,-1,135.651,185.481)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.84,72.028C67.84,72.028 55.827,92.251 55.827,100.918C55.827,107.825 61.21,113.432 67.84,113.432C74.469,113.432 79.852,107.825 79.852,100.918C79.852,92.251 67.84,72.028 67.84,72.028Z",
    style: {
      fill: "white"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.17446,0,0,1.23363,-14.243,-19.9515)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 70.178,
    cy: 85.399,
    rx: 6.011,
    ry: 5.961
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.996176,0,0,1.03771,-491.21,-651.169)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(83.3333,0,0,83.3333,555.045,697.638)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.418,-0.7L0.568,-0.7L0.568,-0L0.418,-0L0.418,-0.047C0.383,-0.006 0.333,0.014 0.269,0.014C0.203,0.014 0.147,-0.012 0.1,-0.063C0.053,-0.114 0.03,-0.176 0.03,-0.25C0.03,-0.324 0.053,-0.387 0.1,-0.438C0.147,-0.489 0.203,-0.514 0.269,-0.514C0.333,-0.514 0.383,-0.494 0.418,-0.453L0.418,-0.7ZM0.213,-0.161C0.235,-0.139 0.264,-0.128 0.299,-0.128C0.334,-0.128 0.363,-0.139 0.385,-0.161C0.407,-0.183 0.418,-0.213 0.418,-0.25C0.418,-0.287 0.407,-0.317 0.385,-0.339C0.363,-0.361 0.334,-0.372 0.299,-0.372C0.264,-0.372 0.235,-0.361 0.213,-0.339C0.191,-0.317 0.18,-0.287 0.18,-0.25C0.18,-0.213 0.191,-0.183 0.213,-0.161Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(83.3333,0,0,83.3333,606.962,697.638)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.193,-0.57C0.176,-0.553 0.155,-0.544 0.13,-0.544C0.105,-0.544 0.084,-0.553 0.067,-0.571C0.049,-0.588 0.04,-0.609 0.04,-0.634C0.04,-0.659 0.049,-0.68 0.067,-0.698C0.084,-0.715 0.105,-0.724 0.13,-0.724C0.155,-0.724 0.176,-0.715 0.194,-0.698C0.211,-0.68 0.22,-0.659 0.22,-0.634C0.22,-0.609 0.211,-0.588 0.193,-0.57ZM0.055,-0L0.055,-0.5L0.205,-0.5L0.205,-0L0.055,-0Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(83.3333,0,0,83.3333,628.212,697.638)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.197,-0.354C0.197,-0.344 0.206,-0.336 0.223,-0.33C0.24,-0.323 0.26,-0.317 0.284,-0.311C0.308,-0.304 0.332,-0.296 0.356,-0.286C0.38,-0.276 0.401,-0.26 0.418,-0.237C0.435,-0.214 0.443,-0.185 0.443,-0.15C0.443,-0.096 0.423,-0.055 0.383,-0.028C0.343,0 0.294,0.014 0.235,0.014C0.13,0.014 0.058,-0.026 0.02,-0.105L0.15,-0.179C0.163,-0.14 0.192,-0.12 0.235,-0.12C0.271,-0.12 0.289,-0.13 0.289,-0.151C0.289,-0.161 0.28,-0.169 0.264,-0.176C0.247,-0.183 0.226,-0.189 0.202,-0.196C0.178,-0.202 0.154,-0.21 0.13,-0.221C0.106,-0.231 0.086,-0.247 0.069,-0.269C0.052,-0.291 0.043,-0.318 0.043,-0.35C0.043,-0.402 0.062,-0.442 0.1,-0.471C0.137,-0.5 0.184,-0.514 0.239,-0.514C0.28,-0.514 0.318,-0.505 0.352,-0.487C0.386,-0.468 0.413,-0.442 0.434,-0.407L0.306,-0.338C0.29,-0.367 0.268,-0.382 0.239,-0.382C0.211,-0.382 0.197,-0.373 0.197,-0.354Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(83.3333,0,0,83.3333,667.212,697.638)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.354,-0.514C0.42,-0.514 0.476,-0.489 0.523,-0.438C0.57,-0.387 0.593,-0.324 0.593,-0.25C0.593,-0.176 0.57,-0.114 0.523,-0.063C0.476,-0.012 0.42,0.014 0.354,0.014C0.29,0.014 0.24,-0.006 0.205,-0.047L0.205,0.2L0.055,0.2L0.055,-0.5L0.205,-0.5L0.205,-0.453C0.24,-0.494 0.29,-0.514 0.354,-0.514ZM0.238,-0.161C0.261,-0.139 0.289,-0.128 0.324,-0.128C0.359,-0.128 0.387,-0.139 0.41,-0.161C0.432,-0.183 0.443,-0.213 0.443,-0.25C0.443,-0.287 0.432,-0.317 0.41,-0.339C0.387,-0.361 0.359,-0.372 0.324,-0.372C0.289,-0.372 0.261,-0.361 0.239,-0.339C0.216,-0.317 0.205,-0.287 0.205,-0.25C0.205,-0.213 0.216,-0.183 0.238,-0.161Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(83.3333,0,0,83.3333,719.129,697.638)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.483,-0.062C0.432,-0.011 0.369,0.014 0.295,0.014C0.221,0.014 0.158,-0.012 0.107,-0.063C0.056,-0.114 0.03,-0.176 0.03,-0.25C0.03,-0.324 0.056,-0.387 0.107,-0.438C0.158,-0.489 0.221,-0.514 0.295,-0.514C0.369,-0.514 0.432,-0.489 0.483,-0.438C0.534,-0.387 0.56,-0.324 0.56,-0.25C0.56,-0.176 0.534,-0.113 0.483,-0.062ZM0.213,-0.165C0.235,-0.143 0.262,-0.132 0.295,-0.132C0.328,-0.132 0.355,-0.143 0.377,-0.165C0.399,-0.187 0.41,-0.215 0.41,-0.25C0.41,-0.285 0.399,-0.313 0.377,-0.335C0.355,-0.357 0.328,-0.368 0.295,-0.368C0.262,-0.368 0.235,-0.357 0.213,-0.335C0.191,-0.313 0.18,-0.285 0.18,-0.25C0.18,-0.215 0.191,-0.187 0.213,-0.165Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(83.3333,0,0,83.3333,768.295,697.638)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.753,-0.39L0.753,-0.33C0.753,-0.225 0.721,-0.142 0.656,-0.08C0.591,-0.017 0.508,0.014 0.408,0.014C0.299,0.014 0.209,-0.021 0.138,-0.091C0.066,-0.161 0.03,-0.247 0.03,-0.349C0.03,-0.451 0.066,-0.537 0.137,-0.608C0.208,-0.679 0.294,-0.714 0.397,-0.714C0.462,-0.714 0.522,-0.699 0.577,-0.67C0.631,-0.641 0.673,-0.602 0.703,-0.554L0.567,-0.476C0.552,-0.5 0.529,-0.52 0.499,-0.535C0.468,-0.55 0.434,-0.558 0.396,-0.558C0.337,-0.558 0.288,-0.538 0.249,-0.499C0.21,-0.46 0.19,-0.409 0.19,-0.348C0.19,-0.287 0.21,-0.238 0.25,-0.2C0.29,-0.161 0.343,-0.142 0.41,-0.142C0.503,-0.142 0.562,-0.178 0.589,-0.25L0.402,-0.25L0.402,-0.39L0.753,-0.39Z",
    style: {
      fill: "rgb(87,150,185)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(83.3333,0,0,83.3333,833.545,697.638)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.418,-0.5L0.568,-0.5L0.568,-0L0.418,-0L0.418,-0.047C0.383,-0.006 0.333,0.014 0.269,0.014C0.203,0.014 0.147,-0.012 0.1,-0.063C0.053,-0.114 0.03,-0.176 0.03,-0.25C0.03,-0.324 0.053,-0.387 0.1,-0.438C0.147,-0.489 0.203,-0.514 0.269,-0.514C0.333,-0.514 0.383,-0.494 0.418,-0.453L0.418,-0.5ZM0.213,-0.161C0.235,-0.139 0.264,-0.128 0.299,-0.128C0.334,-0.128 0.363,-0.139 0.385,-0.161C0.407,-0.183 0.418,-0.213 0.418,-0.25C0.418,-0.287 0.407,-0.317 0.385,-0.339C0.363,-0.361 0.334,-0.372 0.299,-0.372C0.264,-0.372 0.235,-0.361 0.213,-0.339C0.191,-0.317 0.18,-0.287 0.18,-0.25C0.18,-0.213 0.191,-0.183 0.213,-0.161Z",
    style: {
      fill: "rgb(87,150,185)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(83.3333,0,0,83.3333,885.045,697.638)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.197,-0.354C0.197,-0.344 0.206,-0.336 0.223,-0.33C0.24,-0.323 0.26,-0.317 0.284,-0.311C0.308,-0.304 0.332,-0.296 0.356,-0.286C0.38,-0.276 0.401,-0.26 0.418,-0.237C0.435,-0.214 0.443,-0.185 0.443,-0.15C0.443,-0.096 0.423,-0.055 0.383,-0.028C0.343,0 0.294,0.014 0.235,0.014C0.13,0.014 0.058,-0.026 0.02,-0.105L0.15,-0.179C0.163,-0.14 0.192,-0.12 0.235,-0.12C0.271,-0.12 0.289,-0.13 0.289,-0.151C0.289,-0.161 0.28,-0.169 0.264,-0.176C0.247,-0.183 0.226,-0.189 0.202,-0.196C0.178,-0.202 0.154,-0.21 0.13,-0.221C0.106,-0.231 0.086,-0.247 0.069,-0.269C0.052,-0.291 0.043,-0.318 0.043,-0.35C0.043,-0.402 0.062,-0.442 0.1,-0.471C0.137,-0.5 0.184,-0.514 0.239,-0.514C0.28,-0.514 0.318,-0.505 0.352,-0.487C0.386,-0.468 0.413,-0.442 0.434,-0.407L0.306,-0.338C0.29,-0.367 0.268,-0.382 0.239,-0.382C0.211,-0.382 0.197,-0.373 0.197,-0.354Z",
    style: {
      fill: "rgb(87,150,185)",
      fillRule: "nonzero"
    }
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoDarkMode);
export default __webpack_public_path__ + "static/media/logoDarkMode.7adf0211fb8c512c123fbd10e809264f.svg";
export { ForwardRef as ReactComponent };